import { KHAZANAH_COMPANIES } from "./khazanah";
import { STAKEBOAT_COMPANIES } from "./stakeboat";
import { CLAYPOND_COMPANIES } from "./claypond";
import { PULSAR_COMPANIES } from "./pulsar";
import { CARLYLE_COMPANIES } from "./carlyle";
import { CHRYSCAPITAL_COMPANIES } from "./chryscapital";
import { KGOC_COMPANIES } from "./kgoc";
import { DSGROUP_COMPANIES } from "./dsgroup";

const PORTFOLIOS = {
  "khazanah": KHAZANAH_COMPANIES,
  "stakeboat": STAKEBOAT_COMPANIES,
  "claypond": CLAYPOND_COMPANIES,
  "pulsar": PULSAR_COMPANIES,
  "carlyle": CARLYLE_COMPANIES,
  "chryscapital": CHRYSCAPITAL_COMPANIES,
  "kgoc": KGOC_COMPANIES,
  "dsgroup": DSGROUP_COMPANIES,
  // Legacy fund_id keys (for backward compat with any stored tokens)
  "khazanah-demo": KHAZANAH_COMPANIES,
  "stakeboat-demo": STAKEBOAT_COMPANIES,
  "claypond-demo": CLAYPOND_COMPANIES,
  "pulsar-demo": PULSAR_COMPANIES,
  "carlyle-demo": CARLYLE_COMPANIES,
  "chryscapital-demo": CHRYSCAPITAL_COMPANIES,
  "kgoc-demo": KGOC_COMPANIES,
  "dsgroup-demo": DSGROUP_COMPANIES,
};

const FUND_NAMES = {
  "khazanah": "Khazanah Nasional Berhad",
  "carlyle": "The Carlyle Group Asia",
  "chryscapital": "ChrysCapital",
  "claypond": "Claypond Capital",
  "stakeboat": "Stakeboat Capital",
  "pulsar": "Pulsar Capital",
  "kgoc": "Kangaro Group of Companies",
  "dsgroup": "Dharampal Satyapal Group",
  "khazanah-demo": "Khazanah Nasional Berhad",
  "carlyle-demo": "The Carlyle Group Asia",
  "chryscapital-demo": "ChrysCapital",
  "claypond-demo": "Claypond Capital",
  "stakeboat-demo": "Stakeboat Capital",
  "pulsar-demo": "Pulsar Capital",
  "kgoc-demo": "Kangaro Group of Companies",
  "dsgroup-demo": "Dharampal Satyapal Group",
};

export function getPortfolio(slug) {
  return PORTFOLIOS[slug] || [];
}

export function getFundName(slug) {
  return FUND_NAMES[slug] || slug || "Portfolio Fund";
}

export function findCompanyAcrossPortfolios(companyId) {
  const seen = new Set();
  for (const [key, companies] of Object.entries(PORTFOLIOS)) {
    if (seen.has(companies)) continue;
    seen.add(companies);
    const found = companies.find((c) => c.id === companyId);
    if (found) return found;
  }
  return null;
}
